import { render, staticRenderFns } from "./CustomWorkConfirmed.vue?vue&type=template&id=2b6780c0&"
import script from "./CustomWorkConfirmed.vue?vue&type=script&lang=js&"
export * from "./CustomWorkConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./CustomWorkConfirmed.vue?vue&type=style&index=0&id=2b6780c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports